export default __webpack_public_path__ + "static/media/paymentTutorial_pc_bottom_Hk.67a154a6.webp";